import { render, staticRenderFns } from "./DigitalRecordSettings.vue?vue&type=template&id=87a7f6b0&scoped=true"
import script from "./DigitalRecordSettings.vue?vue&type=script&lang=js"
export * from "./DigitalRecordSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a7f6b0",
  null
  
)

export default component.exports